import React from "react";
import styled from "styled-components";

import { Title, DesignTokens } from "melco-ui";

const { spacings, sizes } = DesignTokens;

// const Grid = styled.div`
//   display: grid;
//   grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
//   gap: ${spacings.middle}px;

//   @media screen and (min-width: ${sizes.xxl}px) {
//     grid-template-columns: repeat(7, 1fr);
//   }
// `;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: ${spacings.middle}px;

  @media screen and (min-width: ${sizes.xxl}px) {
    grid-template-columns: repeat(7, 1fr);
  }
`;

type MachineStatusGridProps = {
  title?: string;
  children: React.ReactNode;
};

export const MachineStatusGrid: React.FC<MachineStatusGridProps> = ({
  title,
  children,
}) => {
  return (
    <>
      <Title data-cy-id="machine-status-title" level={5}>
        {title}
      </Title>
      <Grid>{children}</Grid>
    </>
  );
};
